/* @flow */
// typecheck: ignore file
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

type Props = {
  organizationId: number,
  children: (name: string) => React$Element<*>,
  organization?: Object,
}

function AdminLayoutHeaderOrganizationName(props: Props) {
  const { organization } = props;

  if (!organization) {
    return null;
  }

  return props.children(organization.district_name || organization.name);
}

const withOrganization = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      name
      district_name
    }
  }`,
  {
    options: ({ organizationId }) => ({ variables: { organizationId: [organizationId] } }),
    props: ({ data }) => ({ organization: data.organizations ? data.organizations[0] : null }),
  }
);

export { AdminLayoutHeaderOrganizationName };
export default withOrganization(AdminLayoutHeaderOrganizationName);



// WEBPACK FOOTER //
// ./src/admin/components/AdminLayoutHeaderOrganizationName.jsx